import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
@Injectable({
  providedIn: 'root'
})
export class CovidTrackingService {
  private baseUrl = environment.apibaseUrl;

  constructor(private http: HttpClient, public datepipe: DatePipe) { }

  getvaccinTypeList() {
    return this.http.get(this.baseUrl + '/covidtracking/vaccinType/list ');
  }

  getPatientCovidTrackingList() {
    return this.http.get(this.baseUrl + '/covidtracking/list ');
  }

  savePatientCovidTrackingdetails(details) {
    return this.http.post(this.baseUrl + '/covidtracking/save ', details);
  }

  deleteCovidTracking(CovidTrackingId: number) {
    return this.http.delete(this.baseUrl + '/covidtracking/delete?covidTrackingId= ' + CovidTrackingId);
  }

  getCovidTrackingdetails(CovidTrackingId) {
    return this.http.get(this.baseUrl + '/covidtracking/edit?covidTrackingId= ' + CovidTrackingId);
  }

  getPatientListforCovidTracking(patientId) {
    return this.http.get(this.baseUrl + '/covidtracking/patientList?patientId= ' + patientId);
  }

  getNextCovidVaccinationDate() {
    const loginTime = this.datepipe.transform(new Date(), 'yyyy-MM-ddTHH:mm');
    return this.http.get(this.baseUrl + '/covidtracking/nextvaccinationDate?loginTime= ' + loginTime);
  }

  saveModuleConfigInfo(orgId, isCovidTracking, isEnableTheme, themeIdList, waitingRoomlevelId, isClientAppointmentBook, isEnableDonation, paymentUrl, isEnableSponsor, isEnableReferal) {
    const details = new FormData();
    details.append('clinicalOrgId', orgId);
    details.append('isCovidTracking', isCovidTracking);
    details.append('isEnableTheme', isEnableTheme);
    details.append('waitingRoomlevelId', waitingRoomlevelId);
    details.append('isClientAppointmentBook', isClientAppointmentBook);
    details.append('IsEnableDonation', isEnableDonation);
    details.append('PaymentUrl', paymentUrl);
    details.append('isEnableSponsor', isEnableSponsor);
    details.append('isEnableReferal', isEnableReferal);
    if (isEnableTheme && themeIdList.length > 0) {
      themeIdList.forEach(element => {
        details.append('themeIdList', JSON.stringify(element));
      });
    }
    return this.http.post(this.baseUrl + '/covidtracking/saveModuleConfigInfo ', details);
  }

}
